/**
 * @generated SignedSource<<d5944ae93bd0ef79d5fc9afd57ba4812>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaymentLinkActiveValue_company$data = {
  readonly nameFriendly: string | null | undefined;
  readonly " $fragmentType": "PaymentLinkActiveValue_company";
};
export type PaymentLinkActiveValue_company$key = {
  readonly " $data"?: PaymentLinkActiveValue_company$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentLinkActiveValue_company">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaymentLinkActiveValue_company",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "nameFriendly",
      "storageKey": null
    }
  ],
  "type": "Company",
  "abstractKey": null
};

(node as any).hash = "388d0feb30334b6696b6b93f12ca4175";

export default node;
